import React from 'react';

import style from './index.module.scss';

const SelectionOfSuppliersInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Подбор поставщиков на закупку</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>Найти потенциальных поставщиков по разным параметрам и регионам</div>
        <div className={style.descriptionItem}>
          Получить данные по количеству поставщиков, которые поставляют определенные товары и услуги в указанном регионе
        </div>
        <div className={style.descriptionItem}>
          Сформировать перечень поставщиков, принимавших участие в категориях закупок в соответствии с указанным кодом
          ОКПД2
        </div>
      </div>
    </div>
  </>
);

export default SelectionOfSuppliersInfo;
